import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import find from 'lodash/find';
import findIndex from 'lodash/findIndex';

import ProgressBarSVG from '../../../shared/components/ProgressBarSVG';
import ResultsPieChartSVG from '../../../shared/components/ResultsPieChartSVG';

import { countsToRoundedPercents } from '../../../shared/utils';

class QAResults extends Component {
  getVotesForOptionWithId(id){
    const optionKPI = find(this.props.engagementKPIs.answerKPIs, (a) => a.answer === id);

    return optionKPI ? optionKPI.answersNum : 0;
  }

  getWinningOption(){
    const answerKPIs = this.props.engagementKPIs.answerKPIs;

    return answerKPIs.reduce((win,a) => a.answersNum > win.answersNum ? a : win, answerKPIs[0]);
  }

  getSortedOptions(){
    return this.props.engagement.options.sort((a,b) => a.createdDate - b.createdDate);
  }

  render(){
    const { engagement, engagementKPIs } = this.props,
      winningOption = this.getWinningOption();

    const voteCounts = this.getSortedOptions().map((a) => this.getVotesForOptionWithId(a.id)),
      totalVotes = voteCounts.reduce((total,count) => total + count),
      correctVotes = this.getVotesForOptionWithId(engagement.correctAnswerId),
      correctVotesIndex = findIndex(this.getSortedOptions(), (a) => a.id === engagement.correctAnswerId),
      roundedPercents = countsToRoundedPercents(voteCounts);

    console.log('GOT PROPS ',this.props);
    console.log('VOTE COUNTS ',voteCounts);
    console.log('ROUNDED PERCENTS ',roundedPercents);

    return (
      <div className='EngagementResults'>
        <div style={{pageBreakInside:'avoid'}}>
          <Row>
            <Col xs='4'>
              <br />
              <br />
              <h6>Trivia</h6>
              <img
                src={engagement.firstImageURL}
                style={{maxWidth:200,borderRadius:10}}
                alt='Engagement question imagery'
              />
              <br />
              Question Image
            </Col>
            <Col xs='8'>
              <br />
              <br />
              <br />
              {engagement.text}
              <br />
              <br />
              <br />
              <ResultsPieChartSVG
                correctVotes={correctVotes}
                correctVotesPercent={roundedPercents[correctVotesIndex]}
                totalVotes={totalVotes}
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='4'>
              <img
                src={engagement.secondImageURL}
                style={{maxWidth:200,borderRadius:10}}
                alt='Engagement answer imagery'
              />
              <br />
              Answer Detail Image
            </Col>
            <Col xs='8'>
              <br />
              <br />
              {this.getSortedOptions().map((o,i) => {
                return (
                  <ProgressBarSVG
                    key={i}
                    title={o.answer}
                    votes={voteCounts[i]}
                    totalVotes={totalVotes}
                    displayPercent={roundedPercents[i]}
                    winner={winningOption && winningOption.answer === o.id}
                    correct={engagement.correctAnswerId === o.id}
                  />
                );
              })}
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs='12'>
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

QAResults.propTypes = {
  engagement:PropTypes.object.isRequired,
  engagementKPIs:PropTypes.object.isRequired
};

export default QAResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/QAResults.js